import { Component, input } from '@angular/core';
import { SafeHtml } from '../../../../common/pipes/SafeHtml.pipe';
import { StoreService } from '../../../../store/store.service';
import { FADE } from '../../../../common/animations/animations';

@Component({
  standalone: true,
  imports: [SafeHtml],
  selector: 'app-calendar-indications',
  templateUrl: './calendar-indications.component.html',
  styleUrl: './calendar-indications.component.scss',
  animations: [FADE],
  host: {
    '[@fade]': 'true',
  },
})
export class CalendarIndicationsComponent {
  public readonly isCalendarSidepanel = input.required<boolean>();

  constructor(
    public readonly storeSvc: StoreService,
  ) {}
}
